import { 
  Box, 
  Typography, 
  Grid, 
  Paper, 
  Button 
} from '@mui/material';
import CardItem from '../components/CardItem';

export default function Home() {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome to React + MUI Application
      </Typography>
      
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography variant="body1" paragraph>
          This is a starter template using React, Material UI, and Vite for fast development.
          The project structure follows best practices for organizing React applications.
        </Typography>
        <Button variant="contained" color="primary">
          Get Started
        </Button>
      </Paper>
      
      <Grid container spacing={3}>
        {[
          {
            title: 'React',
            description: 'A JavaScript library for building user interfaces',
            imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png',
            actions: [
              { label: 'Learn More', onClick: () => window.open('https://react.dev', '_blank') }
            ]
          },
          {
            title: 'Material UI',
            description: 'A popular React UI framework with beautiful components',
            imageUrl: 'https://mui.com/static/logo.png',
            actions: [
              { label: 'Documentation', onClick: () => window.open('https://mui.com/material-ui/getting-started/', '_blank') }
            ]
          },
          {
            title: 'Vite',
            description: 'Next Generation Frontend Tooling with fast refresh and build times',
            imageUrl: 'https://vitejs.dev/logo.svg',
            actions: [
              { label: 'Get Started', onClick: () => window.open('https://vitejs.dev/guide/', '_blank') }
            ]
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <CardItem
              title={item.title}
              description={item.description}
              imageUrl={item.imageUrl}
              imageAlt={`${item.title} logo`}
              actions={item.actions}
              elevation={2}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}